export default {
  dailyInspections: [],
  dailyInspection: undefined,
};
